import type { ReactNode } from 'react'
import { View } from 'react-native'

import { Placeholder } from '@/src/elements/placeholder'

export const ConversationPlaceholder = (): ReactNode => {
  return (
    <View className="flex-1 justify-end gap-4 overflow-hidden p-4 pb-16">
      <Placeholder contrast="dark" className="h-20 w-40" />
      <Placeholder contrast="dark" className="h-32 w-1/2" />
      <Placeholder contrast="dark" className="h-12 w-1/2 self-end" />
      <Placeholder contrast="dark" className="h-12 w-52" />
      <Placeholder contrast="dark" className="h-12 w-40 self-end" />
      <Placeholder contrast="dark" className="h-12 w-52 self-end" />
    </View>
  )
}
